import { render, staticRenderFns } from "./noteIndex.vue?vue&type=template&id=03cf53c4&scoped=true"
import script from "./noteIndex.vue?vue&type=script&lang=js"
export * from "./noteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf53c4",
  null
  
)

export default component.exports